/**
 * 通过crypto-js实现 加解密工具
 * AES、HASH(MD5、SHA256)、base64
 * @author: ldy
 */
import CryptoJS from "crypto-js";
import stringify from "json-stable-stringify";

const KP = {
  key: "propertyproperty3desskey", // 秘钥 16*n:
  deskey: "qropertyqroperty3desskey", // 秘钥 16*n:
  iv: "01234567" // 偏移量
};

/**
 * aes 加密
 */
function getAesString(data, key, iv) {
  // 加密
  key = CryptoJS.enc.Utf8.parse(key);
  iv = CryptoJS.enc.Utf8.parse(iv);
  data = CryptoJS.enc.Utf8.parse(data);
  let encrypted = CryptoJS.AES.encrypt(data, key, {
    iv,
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  });
  return encrypted.toString(); // 返回的是base64格式的密文
}

/**
 * aes 解密
 */
function getDAesString(encrypted, key, iv) {
  // 解密
  key = CryptoJS.enc.Utf8.parse(key);
  iv = CryptoJS.enc.Utf8.parse(iv);
  let decrypted = CryptoJS.AES.decrypt(encrypted, key, {
    iv,
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  });
  return decrypted.toString(CryptoJS.enc.Utf8); 
}

/**
 * 3des 加密
 */
function getTripleDESString(data, key, iv) {
  // 加密
  key = CryptoJS.enc.Utf8.parse(key);
  iv = CryptoJS.enc.Utf8.parse(iv);
  data = CryptoJS.enc.Utf8.parse(data);
  let encrypted = CryptoJS.TripleDES.encrypt(data, key, {
    iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  });
  return encrypted.toString(); // 返回的是base64格式的密文
}


// AES 对称秘钥加密
const aes = {
  en: data => getAesString(data, KP.key, KP.iv),
  de: data => getDAesString(data, KP.key, KP.iv)
};
// 3DES 对称秘钥加密
const tripleDes = {
  en: data => getTripleDESString(data, KP.deskey, KP.iv)
};

// BASE64
const base64 = {
  en: data => CryptoJS.enc.Base64.stringify(CryptoJS.enc.Utf8.parse(data)),
  de: data => CryptoJS.enc.Base64.parse(data).toString(CryptoJS.enc.Utf8)
};

// SHA256
const sha256 = data => {
  return CryptoJS.SHA256(data).toString();
};

// MD5
const md5 = data => {
  return CryptoJS.MD5(data).toString();
};

/**
 * 签名
 * @param token 身份令牌
 * @param timestamp 签名时间戳
 * @param data 签名数据
 */
const sign = (token, timestamp, data) => {
  let signsrc =
    timestamp +
    token +
    stringify(data, (a, b) => {
      return a.key < b.key ? -1 : 1;
    });

  console.log(signsrc);

  return md5(signsrc);
};

export {
  aes,
  tripleDes,
  md5,
  sha256,
  base64,
  sign
};



// WEBPACK FOOTER //
// ./src/util/crypto.js